import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'redux-scaffolding-ts';
import { AdminReportCountersStore, LoginsAuditItemDataDto } from 'stores/admin-reports/admin-reports-counters-store';
import TailwindMessage from 'site/pages/landing-pages/mobile/alerts/message-tw';
import CounterBoxMobile from './components/counter-box-tw';
import { LineChart, Line, XAxis, YAxis, Tooltip } from 'recharts';

export interface AdminReportCountersMobileProps extends RouteComponentProps, WithTranslation {
  adminReportCounterStore?: AdminReportCountersStore;
}

export interface AdminReportCountersMobileState {
  selectedData: LoginsAuditItemDataDto[];
  graphType: 'WEEK' | 'MONTH' | 'YEAR';
}

@connect(['adminReportCounterStore', AdminReportCountersStore])
class AdminReportCountersMobile extends React.Component<AdminReportCountersMobileProps, AdminReportCountersMobileState> {
  state = {
    selectedData: null,
    graphType: null
  };

  componentDidMount() {
    this.props.adminReportCounterStore.loadCounters().catch(() => undefined);
  }

  private onDraftEventsClick = () => this.props.history.push('/events');
  private onPlannedEventsClick = () => this.props.history.push('/events');
  private onInProgressEventsClick = () => this.props.history.push('/events');
  private onCompletedEventsClick = () => this.props.history.push('/events');
  private onOpenRequestsClick = () => this.props.history.push('/requests');
  private onOpenTheoreticalsClick = () => this.props.history.push('/assessments/theoretical-test?tab=3');
  private onOpenFeedbacksClick = () => this.props.history.push('/assessments/feedbacks');
  private onOpenPracticalsClick = () => this.props.history.push('/assessments/practical-test?tab=3');
  private onLastWeekTotalLoggedUsersClick = () => {
    const { adminReportCounterStore } = this.props;
    this.setState({
      selectedData: this.state.graphType === 'WEEK' ? null : adminReportCounterStore.state.counters.lastWeekLoggedUsersCount,
      graphType: this.state.graphType === 'WEEK' ? null : 'WEEK'
    });
  };
  private onLastMonthTotalLoggedUsersClick = () => {
    const { adminReportCounterStore } = this.props;
    this.setState({
      selectedData: this.state.graphType === 'MONTH' ? null : adminReportCounterStore.state.counters.lastMonthLoggedUsersCount,
      graphType: this.state.graphType === 'MONTH' ? null : 'MONTH'
    });
  };
  private onLastYearTotalLoggedUsersClick = () => {
    const { adminReportCounterStore } = this.props;
    this.setState({
      selectedData: this.state.graphType === 'YEAR' ? null : adminReportCounterStore.state.counters.lastYearLoggedUsersCount,
      graphType: this.state.graphType === 'YEAR' ? null : 'YEAR'
    });
  };
  private onOpenTnasClick = () => this.props.history.push('/assessments/tna?tab=3');
  private onOpenSsasClick = () => this.props.history.push('/assessments/ssa?tab=3');

  render() {
    const {
      t,
      adminReportCounterStore: {
        state: { counters, result, isBusy }
      }
    } = this.props;
    const { selectedData, graphType } = this.state;

    return (
      <>
        {result && !result.isSuccess && (result.messages || []).length > 0 && (
          <TailwindMessage
            className="error-message__style"
            icon="exclamation circle"
            error
            list={result.messages.map(o => o.body)}
            onDismiss={this.props.adminReportCounterStore.clearMessages}
          />
        )}

        <div className="admin-report__counters-container rounded-xl" style={{ borderRadius: '1rem' }}>
          {/* BLOQUE VERDE - 3 columnas */}
          <div className="rounded-xl border border-gray-200 p-2 mb-3" style={{ backgroundColor: '#00B2A920' }}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              <CounterBoxMobile
                color="#00B2A9"
                count={counters.lastWeekTotalLoggedUsersCount}
                title={t('LOGGED USERS LAST WEEK')}
                loading={isBusy}
                clickable
                onClick={this.onLastWeekTotalLoggedUsersClick}
                selected={graphType === 'WEEK'}
                small
              />
              <CounterBoxMobile
                color="#00B2A9"
                count={counters.lastMonthTotalLoggedUsersCount}
                title={t('LOGGED USERS LAST MONTH')}
                loading={isBusy}
                clickable
                onClick={this.onLastMonthTotalLoggedUsersClick}
                selected={graphType === 'MONTH'}
                small
              />
              <CounterBoxMobile
                color="#00B2A9"
                count={counters.lastYearTotalLoggedUsersCount}
                title={t('LOGGED USERS LAST YEAR')}
                loading={isBusy}
                clickable
                onClick={this.onLastYearTotalLoggedUsersClick}
                selected={graphType === 'YEAR'}
                small
              />
            </div>
          </div>

          {/* BLOQUE AMARILLO - 3 columnas, 2 filas */}
          <div className="rounded-xl border border-gray-200 p-2 mb-3" style={{ backgroundColor: '#EAAA0020' }}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              <CounterBoxMobile
                color="#EAAA00"
                count={counters.openTnas}
                title={t('OPEN TNA')}
                loading={isBusy}
                clickable
                onClick={this.onOpenTnasClick}
                small
              />
              <CounterBoxMobile
                color="#EAAA00"
                count={counters.openSsas}
                title={t('OPEN SSA')}
                loading={isBusy}
                clickable
                onClick={this.onOpenSsasClick}
                small
              />
              <CounterBoxMobile
                color="#EAAA00"
                count={counters.openTheoreticalsCount}
                title={t('OPEN THEORETICAL')}
                loading={isBusy}
                clickable
                onClick={this.onOpenTheoreticalsClick}
                small
              />
              <CounterBoxMobile
                color="#EAAA00"
                count={counters.openPracticalsCount}
                title={t('OPEN PRACTICAL')}
                loading={isBusy}
                clickable
                onClick={this.onOpenPracticalsClick}
                small
              />
              <CounterBoxMobile
                color="#EAAA00"
                count={counters.openFeedbacksCount}
                title={t('OPEN FEEDBACK')}
                loading={isBusy}
                clickable
                onClick={this.onOpenFeedbacksClick}
                small
              />
            </div>
          </div>

          {/* BLOQUE ROSA - 3 columnas, 2 filas */}
          <div className="rounded-xl border border-gray-200 p-2 mb-3" style={{ backgroundColor: '#E782A920' }}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              <CounterBoxMobile
                color="#E782A9"
                count={counters.draftEventsCount}
                title={t('DRAFT EVENTS')}
                loading={isBusy}
                clickable
                onClick={this.onDraftEventsClick}
                small
              />
              <CounterBoxMobile
                color="#E782A9"
                count={counters.plannedEventsCount}
                title={t('PLANNED EVENTS')}
                loading={isBusy}
                clickable
                onClick={this.onPlannedEventsClick}
                small
              />
              <CounterBoxMobile
                color="#E782A9"
                count={counters.inProgressEventsCount}
                title={t('IN PROGRESS EVENTS')}
                loading={isBusy}
                clickable
                onClick={this.onInProgressEventsClick}
                small
              />
              <CounterBoxMobile
                color="#E782A9"
                count={counters.completedEventsCount}
                title={t('COMPLETED EVENTS')}
                loading={isBusy}
                clickable
                onClick={this.onCompletedEventsClick}
                small
              />
              <CounterBoxMobile
                color="#E782A9"
                count={counters.openRequestsCount}
                title={t('OPEN REQUESTS')}
                loading={isBusy}
                clickable
                onClick={this.onOpenRequestsClick}
                small
              />
            </div>
          </div>
        </div>

        {selectedData != null && (
          <div className="admin-report__counters__graph-container mt-6 overflow-x-auto">
            <h2 className="admin-report__counters__graph-title text-lg mb-2">{t(`UNIQUE USERS LAST ${graphType}`)}</h2>
            <div style={{ minWidth: 350, width: 'fit-content' }}>
              <LineChart
                width={350}
                height={250}
                data={selectedData}
                margin={{
                  top: 8,
                  right: 20,
                  left: 5,
                  bottom: 5
                }}
              >
                {graphType === 'WEEK' && (
                  <XAxis dataKey="title" padding={{ left: 0, right: 0 }} interval={0} tick={{ fontSize: 10 }} dy={1} />
                )}
                {graphType === 'MONTH' && (
                  <XAxis
                    dataKey="title"
                    interval={1} // Mostrar casi todas las etiquetas
                    tick={({ x, y, payload, index }) => {
                      // Alternar etiquetas muy pegadas para no solapar
                      const offsetY = index % 2 === 0 ? 8 : -8;
                      return (
                        <text x={x} y={y + offsetY} fill="#666" fontSize={10} textAnchor="middle">
                          {payload.value}
                        </text>
                      );
                    }}
                  />
                )}
                {graphType === 'YEAR' && <XAxis dataKey="title" padding={{ left: 2, right: 2 }} interval={0} tick={{ fontSize: 9 }} />}
                <YAxis padding={{ top: 8 }} />
                <Tooltip />
                <Line type="monotone" dataKey="count" stroke="#00B2A9" />
              </LineChart>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withTranslation()(AdminReportCountersMobile);
